import { useAuthContext } from '@/context/AuthContext';
import { useParams } from "react-router-dom";

import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';


const GET_INVOICE_YEARS = gql`
  query ConsultantInvoiceYears($consultantUuid: ID!) {
    consultantInvoiceYears(consultantUuid: $consultantUuid)
  }
`;

// };
export const useConsultantInvoiceYears = () => {
  const { id } = useParams();

  const { loading, error, data, refetch } = useQuery(GET_INVOICE_YEARS, {
    variables: { consultantUuid: id },
    fetchPolicy: "network-only", // Ensures data is always fetched from the server
  });

  return { loading, error, data, refetch };
};
